import { render } from "./retrieve-file.vue?vue&type=template&id=28b7334e&scoped=true"
import script from "./retrieve-file.vue?vue&type=script&lang=js"
export * from "./retrieve-file.vue?vue&type=script&lang=js"

import "./retrieve-file.vue?vue&type=style&index=0&id=28b7334e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b7334e"]])

export default __exports__